import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ProviderNoteRetentionModel } from 'src/app/models/shopping/provider-note-retention.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProviderNoteRetentionService {

  private readonly _httpClient = inject(HttpClient);

  createProviderNoteRetention(providerNoteRetention: ProviderNoteRetentionModel): Observable<ProviderNoteRetentionModel> {
    return this._httpClient.post<ProviderNoteRetentionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerNoteRetention.CreateProviderNoteRetention}`,
      providerNoteRetention);
  }

  deleteProviderNoteRetention(providerNoteRetentionId: number): Observable<ProviderNoteRetentionModel> {
    const params = new HttpParams().set('providerNoteRetentionId', providerNoteRetentionId);
    return this._httpClient.delete<ProviderNoteRetentionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerNoteRetention.DeleteProviderNoteRetention}`,
      { params: params }
    );
  }

  deleteSomeDetails(providerNoteRetentionIds: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerNoteRetention.DeleteSomeDetailsAsync}`,
      providerNoteRetentionIds
    );
  }

  getAllTaxesForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerNoteRetention.GetAllTaxesForSelectAsync}`);
  }

  getColumnsForProviderNoteRetentionAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerNoteRetention.GetColumnsForProviderNoteRetentionAsync}`);
  }

  getProviderNoteRetentionById(providerNoteRetentionId: number): Observable<ProviderNoteRetentionModel> {
    const params = new HttpParams().set('providerNoteRetentionId', providerNoteRetentionId);
    return this._httpClient.get<ProviderNoteRetentionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerNoteRetention.GetProviderNoteRetentionById}`,
      { params: params }
    );
  }

  getProviderNoteRetentionsByProviderNoteIdWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, providerNoteId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant)
      .set('providerNoteId', providerNoteId);
    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerNoteRetention.GetProviderNoteRetentionsByProviderNoteIdWithPagination}`,
      { params: params }
    );
  }

  updateProviderNoteRetention(providerNoteRetention: ProviderNoteRetentionModel): Observable<ProviderNoteRetentionModel> {
    return this._httpClient.put<ProviderNoteRetentionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerNoteRetention.UpdateProviderNoteRetention}`,
      providerNoteRetention);
  }
}
